import {defineStore} from 'pinia';

interface IVersion{
    app_version: string | null;
    status_date: string | null;
}

export const useVersionStore = defineStore('versionStore', {
    // state
    state: ():IVersion => {
        return {
            app_version: null,
            status_date: null
        }
    },
    // getters
    getters: {
        appVersion: (state) => {
            return state.app_version
        },
        statusDate: (state) => {
            return state.status_date
        }
    },
    // actioins
    actions: {
        saveAppVersion(value: string){
            this.app_version = value
        },
        saveStatusDate(){
            this.status_date = new Date().toISOString().split("T")[0]
        }
    }
})